import { useReferralsContext } from '@user/components/Referrals/context'
import { useMemo } from 'react'
import { Props as DrawerProps } from '../UpdateReferralDrawer'

type Props = Pick<DrawerProps, 'referral'>

export function useData(props: Props) {
  const { referral } = props
  const [
    { referralType, referralEmployeeValue, referralCustomerId, referralOther },
  ] = useReferralsContext()

  const drawerTitle = referral ? 'Edit Referral' : 'Add Referral'

  const formValid = useMemo(() => {
    switch (referralType) {
      case 'Customer':
        return referralCustomerId && referralCustomerId.length > 0
      case 'Employee':
        return referralEmployeeValue && referralEmployeeValue.length > 0
      case 'Other':
        return referralOther && referralOther.length > 0
      case 'None':
        return true
      default:
        return false
    }
  }, [referralCustomerId, referralEmployeeValue, referralOther, referralType])

  return { drawerTitle, formValid } as const
}
